<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="'EDIT CLUSTER'">

    <form #mapForm="ngForm" autocomplete="off">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="data.selectedItem.name" maxlength="255" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </form>
</arm-dialog>
